<template>
  <div>
      <div class="relative">
        <img class="banner" :src="detail.banner"/>
        <div class="main-width absolute py-5 bread">
            <VBreadcrumb theme="white" :options="[{ label: '首页', to: '/' }, {label: detail.name}]"></VBreadcrumb>
        </div>
      </div>
      <section class="box relative">
          <div class="main-width">
              <div class="card">
                  <div class="company">
                      <img :src="detail.logo" class="logo"/>
                      <div class="name">
                          <h3>{{ detail.name }}</h3>
                          <h4>{{ detail.en_name }}</h4>
                      </div>
                  </div>
                  <div class="intro">
                    公司介绍
                  </div>
                  <div class="text-desc" v-html="detail.introduction"></div>
                  <div class="img-div" v-show="detail.image">
                      <img class="cruise"  :src="detail.image"/>
                  </div>
              </div>
              <div class="card" v-for="item in detail.introduce" :key="item.title">
                  <div class="main-title">
                      {{ item.title }}
                  </div>
                  <div v-for="(text,index) in item.content" :key="index">
                    <div class="text-desc" v-show="text.attribute_type==1" v-html="text.content"></div>
                    <div v-show="text.attribute_type==2" class="img-div">
                      <img class="cruise" :src="text.url"/>
                    </div>
                  </div>
              </div>
              <div class="card" v-show="detail.cruises && detail.cruises.length">
                  <div class="main-title">
                      旗下邮轮
                  </div>
                  <div class="photos">
                    <a v-for="item in detail.cruises" :key="item.id" :href="cruiseLink(item.id)" target="_blank">
                      <div class="photo">
                        <div class="photo-inner">
                          <img :src="item.image" class="img"/>
                          <div class="mask">
                            <p class="name">{{ item.name }}</p>
                            <p class="en-name">{{ item.en_name }}</p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
              </div>
              <div class="card" v-show="detail.products && detail.products.length">
                  <div class="main-title">
                      相关产品
                  </div>
                  <div class="product">
                      <product-item
                        v-for="item in detail.products"
                        :key="item.product_no"
                        :info="item"
                        @view-trip="handleViewTrip(item)"  @view-date="handleViewTravelDate(item)"
                      ></product-item>
                  </div>
                  <div class="text-center" v-show="detail.products && detail.products.length >= 10">
                      <el-button class="btn-more" @click="seeMore">查看更多产品</el-button>
                  </div>
              </div>
          </div>
      </section>
      <ProductDatesDialog v-if="isOpenViewTravelDate" :visible.sync="isOpenViewTravelDate" :product_no="viewTravelDateState.product_no"></ProductDatesDialog>
      <CruiseTripDialog v-if="isOpenViewTrip" :visible.sync="isOpenViewTrip" :title="viewTripState.title"
						:product_no="viewTripState.product_no" />
      <AppDock />
  </div>
</template>
<script>
import { defineComponent, useRoute, useMeta, ref, useFetch, reactive } from '@nuxtjs/composition-api';
import ProductItem from '@/components/product/prodcutItem.vue'
import { getCompanyDetail } from '@/services/company'
import VBreadcrumb from '@/components/VBreadcrumb.vue'
import AppDock from '~/components/layouts/AppDock.vue'

import ProductDatesDialog from '@/components/product/product-dates-dialog.vue';
import CruiseTripDialog from '@/components/product/cruise-trip-dialog.vue';

import {slice} from '@/utils/helpers';

export default defineComponent({
  name: 'cruiseDetail',
  auth: false,
  head: {},
  layout: 'Main',
  components:{
    ProductItem,
    VBreadcrumb,
    AppDock,
    ProductDatesDialog,
    CruiseTripDialog
  },

  setup() {
    const company_id = ref()
    const route = useRoute();
    company_id.value = route.value.params.companyId

    const detail = ref({})
    const { fetch } = useFetch(async () => {
      const { code, data } = await getCompanyDetail({
        company_id:company_id.value
      })
      if(code === 10000 || code === 200) {
        detail.value = data
      }
    })
    fetch()
    useMeta(() => ({
      // template  #邮轮公司中文名称#,#邮轮公司英文文名称#, #邮轮公司中文名称#相关产品
      title: `${detail.value.name ? detail.value.name +',': ''}${ detail.value.en_name ? detail.value.en_name +',': '' }${detail.value.name ? detail.value.name +'相关产品': ''}`,
      // title: `${detail.value.name} ${detail.value.en_name},品牌公司官方介绍 旗下邮轮,${detail.value.name},${detail.value.en_name},${detail.value.cruises?.reduce((acc,cur)=>(acc + cur.name + ',' + cur.en_name + ','),'')} ${detail.value.products?.reduce((acc,cur)=>(acc + cur.name + ','),'')}上船吧邮轮平台`,
      meta:[
        {
          name: "description",
          // #邮轮公司中文名称#,#邮轮公司英文文名称#,品牌公司官方介绍旗下邮轮,#邮轮中文名称1##邮轮英文名称1#,#邮轮中文名称2#,#邮轮英文名称2#,#邮轮中文名称3##邮轮英文名称3#,上船吧邮轮平台
          // detail.value.name}${detail.value.en_name},${detail.value.cruises?.reduce((acc,cur)=>(acc + cur.name + ',' + cur.en_name + ','),'')
          content:`${detail.value.name ? detail.value.name +',': ''}${detail.value.en_name ? detail.value.en_name+',品牌公司官方介绍旗下邮轮':''}${ slice(detail.value.cruises, 3).length ? slice(detail.value.cruises, 3).map(item => `${item.name}${item.en_name? ','+item.en_name:''}`).join(',')+',' :''}上船吧邮轮平台`,
          hid: "description",
        },
        {
          name:"keywords",
          content:`${detail.value.name}${detail.value.en_name? ' '+detail.value.en_name :''},品牌公司官方介绍`,
          hid:'keywords'
        }
      ]
    }));


     // ======================= 查看行程 =======================
		const isOpenViewTrip = ref(false);
		const viewTripState = reactive({
			title: '',
			product_no: '',
			// tours: []
		})
		const handleViewTrip = async (product) => {
			isOpenViewTrip.value = true;
			viewTripState.title = product.name;
			viewTripState.product_no = product.product_no;
		}

        // ======================= 查看出游日期 =======================
		const isOpenViewTravelDate = ref(false);
		const viewTravelDateState = reactive({
			product_no: '',
		})
		const handleViewTravelDate = async (product) => {
			isOpenViewTravelDate.value = true;
			console.log(product);
			viewTravelDateState.product_no = product.product_no;
		}
    return {
      company_id,
      detail,


      isOpenViewTrip,
			viewTripState,
			handleViewTrip,

      isOpenViewTravelDate,
			viewTravelDateState,
			handleViewTravelDate
    }
  },

  data(){
    return {
      status:{
        expanded:false,
        index:0,
      },
    }
  },
  methods:{
    toggleStatus(index){
      if(this.status.index == index){
        this.status.expanded = !this.status.expanded
      }else{
        this.status.index = index
        this.status.expanded = true
      }
    },
    seeMore(){
      window.open(`/product/automation/foreign-cruise-search?brand=${this.company_id}`,'_blank')
    },
    cruiseLink(cruiseId){
      return `/company/cruise/${cruiseId}`
    }
  }
})
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 356px;
  display: block;
  object-fit: cover;
}
.bread {
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 1;
}
.box {
  padding-bottom: 70px;
  margin-top: -146px;
}
.box .card {
  padding: 28px 0;
  margin-bottom: 18px;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.1);
  border-radius: 4px;
  background-color: #fff;
}
.box .card .company {
  display: flex;
  padding-bottom: 28px;
  border-bottom: 1px solid #e7e7e7;
}
.box .card .company .logo {
  width: 115px;
  height: 40px;
  margin-left: 28px;
  margin-right: 20px;
  object-fit: cover;
  border: 1px solid #979AA8;
  border-radius: 4px;
}
.box .card .company .name {
  padding-top: 5px;
}
.box .card .company .name h3 {
  font-size: 30px;
  color: $color-black-2;
  line-height: 1;
  font-weight: 500;
}
.box .card .company .name h4 {
  font-size: 18px;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
.box .card .intro {
  padding: 36px 28px 25px 28px;
  color: $color-black-2;
  font-size: 26px;
  font-weight: 500;
}
.box .card .text-desc {
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
  font-size: 18px;
  padding: 0 28px;
  white-space: pre-line;
}
.box .card .img-div {
  padding: 18px 28px 0 28px;
}
.box .card .cruise {
  display: block;
  width: 586px;
  margin: 0 auto;
}
.box .card .main-title {
  padding: 0 28px 20px 28px;
  font-size: 26px;
  color: $color-black-2;
  font-weight: 500;
}
.box .card .photos {
  margin-right: -30px;
  margin-bottom: -30px;
  padding: 0 28px;
  overflow: hidden;
}
.box .card .photos .photo {
  width: 33.33%;
  padding-right: 30px;
  margin-bottom: 30px;
  float: left;
}
.box .card .photos .photo-inner {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  height: 210px;
}
.box .card .photos .photo-inner .img {
  width: 100%;
  height: 210px;
  object-fit: cover;
  transition: all 0.3s;
}
.box .card .photos .photo-inner .mask {
  position: absolute;
  padding: 65px 0 0 23px;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 137px;
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
}
.box .card .photos .photo-inner .mask .name {
  color: #fff;
  font-size: 26px;
}
.box .card .photos .photo-inner .mask .en-name {
  font-size: 14px;
  color: #fff;
}
.box .card .photos .photo-inner:hover .img {
  transform: scale(1.2);
}
.box .card ::v-deep .product > div:last-child .goods {
  border-bottom: none;
}
.box .card .btn-more {
  width: 200px;
  height: 44px;
  font-size: 16px;
  color: $color-black-2;
  border: 1px solid $color-black-2;
  border-radius: 4px;
}
</style>
